// extracted by mini-css-extract-plugin
export default {"credentials":"profile_credentials__AN+sW","form":"profile_form__lHJcn","formButton":"profile_formButton__x35R4"};